module.exports = __webpack_public_path__ + "img/tempo-pointer.1290d1d5.png";